import { render, staticRenderFns } from "./customer-product-qantity.vue?vue&type=template&id=6077153c"
import script from "./customer-product-qantity.vue?vue&type=script&lang=js"
export * from "./customer-product-qantity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6077153c')) {
      api.createRecord('6077153c', component.options)
    } else {
      api.reload('6077153c', component.options)
    }
    module.hot.accept("./customer-product-qantity.vue?vue&type=template&id=6077153c", function () {
      api.rerender('6077153c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/stat-analyze/customer-analyze/customer-product-qantity.vue"
export default component.exports